import worldMap from '../core/map';
import translate from '../core/tools/translate';
import { CoreControl } from './CoreControl';
import DefaultType from './DefaultType';

export class MapsControl extends CoreControl {
    constructor() {
        super({ name: 'Maps' });
    }

    static getInstance() {
        if (!MapsControl._instance) {
            MapsControl._instance = new MapsControl();
        }

        return MapsControl._instance;
    }

    init() {
        const values = {
            help: translate(`Help.${this.options.name}`),
            id: 'layer-maps',
            label: translate(`Common.${this.options.name}`),
            change: this._change,
            name: this.options.name,
            type: 'raster-maps',
            dropdown: {
                name: 'layers',
                dataSource: [
                    { text: 'Default', value: 'default' },
                    { text: 'Roads', value: 'roads' },
                    { text: 'Simple', value: 'cartodb' },
                    { text: 'Colored', value: 'openstreet' },
                    { text: 'Grayscale', value: 'grayscale' },
                    { text: 'Satellite', value: 'sattelite' },
                    { text: translate('Common.NoMap'), value: 'nomap' }
                ],
                change: worldMap.setLayer
            }
        };

        if (!this._instance) {
            this._instance = new DefaultType(values);
        }
    }
}

export default MapsControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/MapsControl.js